module.exports = __webpack_public_path__ + "static/media/gemBlue.5872aa69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gemBlue.png
// module id = 198
// module chunks = 0